/** Builder-only cross-check of the stored line-item cost split against the quoted subtotal. */
import { getEditedQuotedLineSplit, getQuotedLineSplit } from "@workspace/api-zod/quote-cost-split";
export interface CostSplitLine {
  id?: string;
  quantity: string | number;
  unitCost: string | number;
  subtotal?: string | number | null;
  labourCost?: string | number | null;
  materialCost?: string | number | null;
  plantCost?: string | number | null;
  isOptional?: boolean | null;
}

const money = (amount: number) => Math.round(amount * 100) / 100;

export function calculateQuoteCostTotals(
  items: CostSplitLine[],
  quotedSubtotal: number,
  originalItems?: CostSplitLine[],
) {
  const originalById = new Map(originalItems?.map(item => [item.id, item]) ?? []);
  const totals = { labour: 0, materials: 0, plant: 0 };
  for (const item of items) {
    if (item.isOptional) continue;
    const original = item.id ? originalById.get(item.id) : undefined;
    const split = original ? getEditedQuotedLineSplit(item, original) : getQuotedLineSplit(item);
    totals.labour += split.labourCost;
    totals.materials += split.materialCost;
    totals.plant += split.plantCost;
  }
  const labour = money(totals.labour);
  const materials = money(totals.materials);
  const plant = money(totals.plant);
  return {
    labour,
    materials,
    plant,
    difference: (Math.round(quotedSubtotal * 100) - Math.round(labour * 100)
      - Math.round(materials * 100) - Math.round(plant * 100)) / 100,
  };
}